/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Defects_Grand_TotalInputs */

const vi_warehouse_defects_grand_total = /** @type {(inputs: Warehouse_Defects_Grand_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng toàn kỳ`)
};

/**

* @param {Warehouse_Defects_Grand_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_defects_grand_total = /** @type {((inputs?: Warehouse_Defects_Grand_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Defects_Grand_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_defects_grand_total(inputs)
});